import React from "react";
import { Pressable, StyleSheet, Text } from "react-native";
import { ChevronDown } from "../assets/icons";
import { formatPeriod } from "../Utils/formatPeriod";

export default function ReportPeriodSelector({ period, disabled, onPress }) {
  const formattedPeriod = formatPeriod(period) || "Belum tersedia";

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={`Periode ${formattedPeriod}`}
      onPress={onPress}
      disabled={disabled}
      style={styles.button}
    >
      <Text style={styles.label}>Periode</Text>
      <Text style={[styles.value, !period && styles.unavailable]}>
        {formattedPeriod}
      </Text>
      <ChevronDown width={16} height={16} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    minHeight: 54,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  label: {
    flex: 1,
    color: "#151515",
    fontFamily: "Archivo-Bold",
    fontSize: 12,
  },
  value: {
    color: "#5423B5",
    fontFamily: "Archivo-Regular",
    fontSize: 12,
  },
  unavailable: { color: "#999999" },
});
